export const SPARTAN_ENGINE_SPEC_LABELS = {
  horsepower: 'กำลังสูงสุด',
  torque: 'แรงบิดสูงสุด',
} as const;

export const SPARTAN_ENGINE_SPEC_UNITS = {
  horsepower: 'PS',
  torque: 'N.m',
} as const;

export const SPARTAN_ENGINE_SPEC_LABELS_WITH_UNITS = {
  horsepower: `${SPARTAN_ENGINE_SPEC_LABELS.horsepower} (${SPARTAN_ENGINE_SPEC_UNITS.horsepower})`,
  torque: `${SPARTAN_ENGINE_SPEC_LABELS.torque} (${SPARTAN_ENGINE_SPEC_UNITS.torque})`,
} as const;
